import React, {useState} from 'react';
import {useNavigation} from '@react-navigation/native';
import {
  SectionContainer,
  SectionHeader,
  TitleRow,
  IconWrapper,
  FipeIcon,
  TitleColumn,
  Title,
  Subtitle,
  FormRow,
  InputWrapper,
  ButtonWrapper,
} from './styles';
import {Input} from '../../../../components/Interface/Forms/Inputs/Input';
import {Button} from '../../../../components/Interface/Forms/Buttons/Button';

export function FipeSection() {
  const navigation = useNavigation();
  const [placa, setPlaca] = useState('');

  function handleNavigateToFipe(){
    setPlaca('');
    navigation.navigate('LoadingFipe', {placa});
  }

  return (
    <SectionContainer>
      <SectionHeader>
        <TitleRow>
          <IconWrapper>
            <FipeIcon />
          </IconWrapper>
          <TitleColumn>
            <Title>Consultar FIPE</Title>
            <Subtitle>Consulte a tabela pela placa do veículo</Subtitle>
          </TitleColumn>
        </TitleRow>
      </SectionHeader>

      <FormRow>
        <InputWrapper>
          <Input
            placeholder="Digite a placa"
            mask={'[AAA]-[0-99]'}
            onChangeText={extracted => setPlaca(extracted.toUpperCase() ?? '')}
            value={placa}
            autoCapitalize="characters"
            keyboardType="default"
          />
        </InputWrapper>
        <ButtonWrapper>
          <Button
            title="Consultar"
            enabled={placa.length >= 7}
            onPress={() => handleNavigateToFipe()}
          />
        </ButtonWrapper>
      </FormRow>
    </SectionContainer>
  );
}
